const chatMessageEl = (isUserPrompt = true) => {
    const el = document.createElement('div');

    el.classList.add(
        'kui-chat-message',
        ...(isUserPrompt ? ['is-user', 'is-latest'] : ['is-response'])
    );
    el.setAttribute('role', 'group');

    return el;
};

const markdownEl = () => {
    const el = document.createElement('div');
    el.dataset.marked = 'true';
    el.dataset.markedSpacing = 'small';

    return el;
};

const spinnerEl = (isSmall) => {
    const el = document.createElement('span');
    el.dataset.kuiSpinner = 'true';
    el.className = 'kui-spinner';
    el.setAttribute('aria-hidden', 'true');

    if (isSmall) {
        el.classList.add('kui-spinner--size-small');
    }

    const elContents = `
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g
                fill="transparent"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-width="8px"
            >
                <circle cx="50" cy="50" r="45"></circle>
                <circle cx="50" cy="50" r="45"></circle>
            </g>
        </svg>
    `;
    el.innerHTML = elContents;

    return el;
};

const toolsEl = () => {
    const el = document.createElement('div');
    el.classList.add('kui-chat-message__tools');

    return el;
};

const toolItemEl = () => {
    const root = document.createElement('div');
    const spinner = spinnerEl();
    const text = document.createElement('p');

    root.classList.add('kui-chat-message__tool-item');
    root.appendChild(spinner);
    root.appendChild(text);

    return {root, spinner, text};
};

export {chatMessageEl, markdownEl, spinnerEl, toolsEl, toolItemEl};
